var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"m-popover",style:([_vm.position])},[_c('div',{staticClass:"m-popover_content",style:({
      '--borderRadius': _vm.radiusNum
    })},[_vm._t("default")],2),_c('div',{staticClass:"m-popover_arrow"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }